const data = ['AC', '+/-', '%', '/', '1', '2', '3', 'x',
  '4', '5', '6', '+', '7', '8', '9', '-', '0', '.', '=',
];

export default data;
